import axiosInstance from "./AxiosInstance";

export function getUnitOfDoses(
  pagination,
  pageid,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("unit-of-dose/list", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
  });
}

export function createUnitOfDose(unitDoseData) {
  return axiosInstance.post("unit-of-dose/add", unitDoseData);
}

export function updateUnitOfDose(unitDoseData) {
  return axiosInstance.post("unit-of-dose/edit", {
    ...unitDoseData,
  });
}

export function deleteUnitOfDose(unitDoseId) {
  return axiosInstance.post("unit-of-dose/delete", {
    unit_id: unitDoseId,
  });
}

export function formatUnitOfDoses(data = []) {
  return data.map((unit) => ({
    id: unit.unit_id,
    unit_text: unit.unit_text,
   unit_status: unit.unit_status,
    created_at: unit.created_at,
    updated_at: unit.updated_at,
  }));
}
